import PhoneMaskInput from './PhoneMaskInput';

export default PhoneMaskInput;
